import React from 'react'

const CloudUploadSvg = () => {
  return (
    <>
      <svg
        width='25'
        height='20'
        viewBox='0 0 25 20'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M16.5073 14.0005L12.5073 10.0005M12.5073 10.0005L8.50729 14.0005M12.5073 10.0005V19.0005M20.8973 16.3905C21.8726 15.8587 22.6431 15.0174 23.0872 13.9991C23.5312 12.9808 23.6235 11.8437 23.3495 10.7672C23.0755 9.69062 22.4508 8.73598 21.574 8.05392C20.6971 7.37185 19.6181 7.00121 18.5073 7.00047H17.2473C16.9446 5.82971 16.3804 4.74281 15.5972 3.82147C14.814 2.90012 13.8321 2.16832 12.7254 1.68108C11.6186 1.19384 10.4158 0.963831 9.2074 1.00835C7.99897 1.05288 6.81635 1.37077 5.74846 1.93814C4.68057 2.5055 3.7552 3.30758 3.04191 4.28405C2.32862 5.26053 1.84597 6.38601 1.63026 7.57587C1.41455 8.76572 1.47139 9.989 1.7965 11.1537C2.12161 12.3185 2.70653 13.3943 3.50729 14.3005'
          stroke='#1E1E1E'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </>
  )
}

export default CloudUploadSvg